<template>
  <div id="about" class="about-wrap style8 pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img
              src="../../assets/images/about/about-img-14.jpg"
              alt="Image"
              class="about-img-one"
            />
            <img
              src="../../assets/images/about/about-img-15.jpg"
              alt="Image"
              class="about-img-two"
            />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="300"
        >
          <div class="about-content">
            <div class="content-title style1">
              <span>About us</span>
              <h2>
                We Provide Special Care Through Our
                <span>Certified &amp; Experience</span> Doctors
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem has standard dummy text ever since the 1500s,
                when an unknown.
              </p>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content when looking at its layout. The point of
                using Lorem Ipsum is that amet has a moreorless normal
                distribution of letters as opposed dolor.
              </p>
            </div>

            <ul class="content-feature-list list-style style3 mb-0">
              <li>
                <span><i class="ri-check-double-line"></i></span>Physical
                Therapy
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Nurse
                Practitioners
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Physician
                Assistant
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Chiropratic
                Mentor
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>